import { getFormatedDate } from '@utils';
import * as yup from 'yup';
import docs from './attachments';
import { nome } from './utils/rulesByKey';

export const TempoContribuicaoSchema = yup.object({
  ...nome,
  inicio: yup
    .date()
    .max(getFormatedDate(new Date().toLocaleDateString('pt')))
    .required('Atenção, Data de início inválida.'),
  termino: yup
    .date()
    .max(getFormatedDate(new Date().toLocaleDateString('pt')))
    .required('Atenção, Data de término inválida.'),
  tempoEspecial: yup.bool(),
  ...docs.TempoContribuicaoDocs.rules,
});

export const TempoContribuicaoInitialValues = {
  nome: '',
  inicio: '',
  termino: '',
  tempoEspecial: false,
  ...docs.TempoContribuicaoDocs.initialValues,
};

export const TempoContribuicaoDocs = docs.TempoContribuicaoDocs.docs;
